module.exports = __webpack_public_path__ + "img/shiming@2x.f858fed8.png";